export default __webpack_public_path__ + "static/media/logo-white.bc9a0845.png";